import { useState } from 'react';

/**
 * Shared search and filter component for sidebar lists
 * Used in Users, Products, and Roles sections
 */
export default function SidebarSearchFilter({
  searchQuery = '',
  onSearchChange,
  showActiveFilter = false,
  activeFilter = 'all', // 'all', 'active', 'inactive'
  onActiveFilterChange,
  placeholder = 'Search...',
}) {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleClearSearch = () => {
    onSearchChange('');
  };

  return (
    <div className="p-4 border-b border-gray-700 space-y-3">
      {/* Search Input */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          className="block w-full pl-10 pr-10 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        />
        {searchQuery && (
          <button
            onClick={handleClearSearch}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-white"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Active/Inactive Filter (optional) */}
      {showActiveFilter && (
        <div className="flex gap-2">
          <button
            onClick={() => onActiveFilterChange('all')}
            className={`flex-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
              activeFilter === 'all'
                ? 'bg-purple-600'
                : 'bg-gray-800 text-white hover:bg-gray-700'
            }`}
          >
            All
          </button>
          <button
            onClick={() => onActiveFilterChange('active')}
            className={`flex-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
              activeFilter === 'active'
                ? 'bg-purple-600'
                : 'bg-gray-800 text-white hover:bg-gray-700'
            }`}
          >
            Active
          </button>
          <button
            onClick={() => onActiveFilterChange('inactive')}
            className={`flex-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
              activeFilter === 'inactive'
                ? 'bg-purple-600'
                : 'bg-gray-800 text-white hover:bg-gray-700'
            }`}
          >
            Inactive
          </button>
        </div>
      )}
    </div>
  );
}
